import React, { useState, useEffect } from "react";
import '../../sass/components/flexibleModules/_components.platformScrollingTicker.scss';
import Slider from "react-slick";
import "../../sass/slick/slick.min.scss"
import "../../sass/slick/slick-theme.min.scss"

const PlatformScrollingTicker = ({ data }) => {

    // Using state to render after component is mounted, as SLick is causing issues without responsive versions
    const [isRendered, setIsRendered] = useState(false)

    let settings = {
        dots: false,
        infinite: true,
        autoplay: true,
        cssEase: 'linear',
        arrows: false,
        speed: 8000,
        slidesToShow: 4,
        slidesToScroll: 1,
        draggable: false,
        centerMode: true,
        centerPadding: '250px',
        swipeToSlide: true,
        touchThreshold: 250,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 1700,
                settings: {
                    slidesToShow: 4,
                    centerPadding: '100px',
                }
            },
            {
                breakpoint: 1600,
                settings: {
                    slidesToShow: 3,
                    centerPadding: '100px',
                }
            },
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 3,
                    centerPadding: '10px',
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    centerPadding: '10px',
                }
            },
            {
                breakpoint: 580,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '10px',
                }
            }
        ]
    };
    useEffect(() => {
        setIsRendered(true)
    }, []);

    return (
        <div className="cp-platformScrollingTicker" style={{ backgroundColor: `${data.backgroundColor ? data.backgroundColor : ""}` }}>
            <div className="cp-platformScrollingTicker__inner" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                {data.platformScrollingTickerRepeaterField &&
                    <>
                        {isRendered && (
                            <Slider {...settings}>
                                {data.platformScrollingTickerRepeaterField.map((blogItem, index) => (
                                    <div className="cp-scrollingText" key={index}>
                                        <p dangerouslySetInnerHTML={{ __html: blogItem.text }} />
                                    </div>
                                ))}
                            </Slider>
                        )}
                    </>
                }
            </div>
        </div>
    );
}

export default PlatformScrollingTicker;